import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';

interface Props {
  userRole: string | null;
}

const LeaveManagementView: React.FC<Props> = (prop) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate(`/leave-management/apply-leave`);
  }, []);

  return <></>;
};

export default LeaveManagementView;
